import { Link } from "react-router-dom";
import CookieSettingsButton from "@/components/legal/CookieSettingsButton";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-12 md:py-16 -mt-px">
      <div className="container mx-auto px-4">
        {/* Cinq blocs : marque en pleine largeur puis 2 colonnes sur mobile, une ligne de 5 sur grand écran
            (la grille à 4 colonnes renvoyait « Contact » seul sur une seconde ligne). */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-transparent flex items-center justify-center overflow-hidden">
                <img
                  src="/logo.webp"
                  alt=""
                  width={36}
                  height={36}
                  decoding="async"
                  loading="lazy"
                  className="w-9 h-9 object-contain"
                />
              </div>
              <span className="text-payfit-value !text-background">Equiply</span>
            </Link>
            <p className="text-payfit-body !text-background/70 leading-relaxed">
              La solution de gestion de planning pour les franchisés de magasins de proximité.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-payfit-body mb-4 !text-background">Produit</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/#features" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Fonctionnalités
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  À propos
                </Link>
              </li>
            </ul>
          </div>

          {/* Ressources — footer focalisé : 4 liens stratégiques + lien vers le hub /ressources */}
          <div>
            <h3 className="text-payfit-body mb-4 !text-background">Ressources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/convention-idcc-1505" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Convention IDCC 1505
                </Link>
              </li>
              <li>
                <Link to="/franchise-alimentaire-proximite" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Franchisés de proximité
                </Link>
              </li>
              <li>
                <Link to="/alternative-excel-planning" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Alternative à Excel
                </Link>
              </li>
              <li>
                <Link to="/ressources" className="text-payfit-body !text-background/70 hover:!text-background transition-colors font-semibold">
                  Toutes les ressources →
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-payfit-body mb-4 !text-background">Légal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="text-payfit-body !text-background/70 hover:!text-background transition-colors">
                  CGU
                </Link>
              </li>
              <li>
                <CookieSettingsButton className="text-payfit-body !text-background/70 hover:!text-background transition-colors text-left" />
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-payfit-body mb-4 !text-background">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:contact@equiply.fr"
                  className="text-payfit-body !text-background/70 hover:!text-background transition-colors"
                >
                  contact@equiply.fr
                </a>
              </li>
              <li>
                <span className="text-payfit-body !text-background/70">
                  Support : <span className="whitespace-nowrap">Lun-Ven 9h-18h</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-background/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-payfit-body !text-background/50">
              © {new Date().getFullYear()} Equiply. Tous droits réservés.
            </p>
            <p className="text-payfit-body !text-background/50">
              Fait avec ❤️ en France
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
